export class TransactionSearch {
    emailId?: string;
    startDate: Date;
    endDate: Date;
}
